import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "data-table-container" }
const _hoisted_2 = { class: "data-table-title-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_draggable = _resolveComponent("draggable")!
  const _component_add_code = _resolveComponent("add-code")!
  const _component_q_markup_table = _resolveComponent("q-markup-table")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_expansion_item, {
      "model-value": true,
      class: "io-mfe-ig-expansion-item"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, _toDisplayString(this.$props.title), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_q_markup_table, {
          class: "data-table",
          dense: "",
          flat: "",
          "hide-bottom": ""
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "dt-thead"),
            _createVNode(_component_draggable, {
              list: this.rows,
              "item-key": "id",
              tag: "tbody",
              onUpdate: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('reorder', $event))),
              onStart: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('dragStart', $event)))
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "dt-rows")
              ]),
              _: 3
            }, 8, ["list"]),
            _createVNode(_component_add_code, {
              columns: _ctx.columns || [],
              type: _ctx.type
            }, null, 8, ["columns", "type"])
          ]),
          _: 3
        })
      ]),
      _: 3
    })
  ]))
}